import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/weed-control-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/weed-control",
      statusCode: 301,
    });
  },
});
